import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-dialog-link-info',
  templateUrl: './dialog-link-info.component.html',
  styleUrls: ['./dialog-link-info.component.scss']
})
export class DialogLinkInfoComponent implements OnInit {

  constructor(
    public readonly dialogRef: MatDialogRef<DialogLinkInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public readonly data: any,
  ) { }

  ngOnInit(): void {
  }

}
